module.exports = __webpack_public_path__ + "static/media/Sympl.9d917914.png";